export default __webpack_public_path__ + "static/media/fly-dubai-ads.edb13244.png";